const SkipNavLink = () => {
	return (
		<>
			<a href="#container" className="skipnavigation">
				<span>본문 영역으로 바로가기</span>
			</a>
			<a href="#footer" className="skipnavigation">
				<span>하단 메뉴로 바로가기</span>
			</a>
		</>
	);
};

export default SkipNavLink;
